module.exports = __webpack_public_path__ + "static/media/equitorials.76c3679d.jpg";